export default {
    getBlogs(state) {
        return state.blogs
    },
    getBlogDetails(state) {
        return state.blogsDetails
    },
    getContactPage(state) {
        return state.contact_page
    },
    getAllCampaign(state) {
        return state.all_campaigns
    },
    getCampaignProducts(state) {
        return state.campaign_products
    },
    getCampaignBrands(state) {
        return state.campaign_brands
    },
    getCampaignShops(state) {
        return state.campaign_shops
    },
    getCampaign(state) {
        return state.campaign
    },
    getBlogCategories(state) {
        return state.blogCategories
    },
    getBlogTags(state) {
        return state.blogTags
    },
    getShopCategories(state) {
        return state.shop_categories;
    },
    getShopBrands(state) {
        return state.shop_brands;
    },
    getShopColors(state) {
        return state.shop_colors;
    },
    getShopAttributes(state) {
        return state.shop_attributes;
    },
    getDailyDeals(state) {
        return state.daily_deals;
    },
    getRecentPosts(state) {
        return state.recent_posts;
    },
    getProductDetails(state) {
        return state.product_details;
    },

    getReplyForm(state) {
        return state.reply_form;
    },
    getBlogComments(state) {
        return state.blog_comments;
    },
    getPageData(state) {
        return state.get_page_data;
    },
    getCompareList(state) {
        return state.compare_list;
    },
    getProfileOrders(state) {
        return state.profile_orders;
    },
    getUserOrderList(state) {
        return state.userOrderList;
    },
    getProductAttributes(state) {
        return state.product_attributes;
    },
    getUserCoupons(state) {
        return state.userCoupons;
    },
    getAllWishlists(state) {
        return state.allWishlist;
    },
    getUserWishlist(state) {
        return state.wishlist_products;
    },
    getShop(state) {
      return state.get_shop
    },    
    getUserCompare(state) {
        return state.compare_products;
    },
    getDefaultCurrency(state) {
        return state.default_currency;
    },
    getCarts(state) {
        return state.carts
    },
    getHomeComponents(state) {
        return state.home_components;
    },
    getHomeResults(state) {
        return state.home_results;
    },
    getCountCompare(state) {
        return state.countCompare;
    },
    getShimmer(state) {
        return state.shimmer;
    },
    getAllCategories(state) {
        return state.allCategories
    },
    getAllBrands(state) {
        return state.allBrands
    },
    getAllSellers(state) {
        return state.allSellers
    },
    getDefaultAssets(state) {
        return state.default_assets;
    },
    getProducts(state) {
        return state.products;
    },
    getCategoryProducts(state) {
        return state.category_products;
    },
    getBrandProducts(state) {
        return state.brand_products
    },
    getCategoryPage(state) {
        return state.category_page;
    },
    getBrandPage(state) {
        return state.brand_page;
    },
    getSellerPage(state) {
        return state.seller_page;
    },
    getOfferProducts(state) {
        return state.offer_products;
    },
    getSellingProducts(state) {
        return state.selling_products;
    },
    getFilterLoaded(state) {
        return state.filter_loaded;
    },
    getUserAddresses(state) {
        return state.userAddresses;
    },
    getAddons(state) {
        return state.addons;
    },
    getWalletRecharges(state) {
        return state.wallet_recharges;
    },
    getRewards(state) {
        return state.rewards;
    },
    getOrderUrl(state) {
        return state.order_urls;
    },
    getInvoices(state) {
        return state.invoices;
    },
    getShopFollwer(state){
        return state.shop_follwer
    },
    getLoginRedirection(state)
    {
        return state.login_redirect;
    },
    getTotalReward(state)
    {
        return state.total_reward;
    },
    getNotifications(state)
    {
        return state.notifications;
    },
    getFollowedSellers(state)
    {
        return state.followedSellers;
    },
    getActiveModal(state)
    {
        return state.active_modal;
    },
    getLangKeywords(state)
    {
        return state.lang_keywords;
    },
    getShopContents(state)
    {
        return state.shop_contents;
    },
    getShopComponent(state)
    {
        return state.shop_component_names;
    },
    getCommonData(state){
        return state.common_data;
    },
    getPaymentData(state)
    {
        return state.payment_data;
    },
    getSellerCoupons(state) {
        return state.seller_coupons;
    },
    getSellerProducts(state) {
        return state.seller_products
    },
    getActiveTab(state) {
        return state.active_tab;
    },
    getPriceRange(state) {
        return state.price_range;
    },
    getCountryList(state) {
        return state.countryList;
    },
    getResponseDone(state)
    {
        return state.response_done;
    },
    getVideoShops(state)
    {
        return state.video_shops;
    },
    getVideoDetails(state)
    {
        return state.video_details;
    },
    getSliderBanners(state)
    {
        return state.slider_banners;
    },
    getMobileNo(state) {
        return state.phone;
    },
    getHomeScroller(state) {
        return state.home_scroller;
    },
    getSidebarCategory(state) {
        return state.sidebar_category;
    },
    getSmCategory(state) {
        return state.show_sm_category;
    },
}
